import { useCallback, useEffect, useState } from 'react';

export default function useSidebarState({ isNarrowScreen }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (!isNarrowScreen) setSidebarOpen(false);
  }, [isNarrowScreen]);

  const closeSidebar = useCallback(() => {
    if (isNarrowScreen) setSidebarOpen(false);
  }, [isNarrowScreen]);

  const toggleSidebar = useCallback(() => setSidebarOpen((prev) => !prev), []);

  return { sidebarOpen, closeSidebar, toggleSidebar };
}
